export const nextListVehicleId = (vehicleIds, currentId) => {
    const currentIndex = vehicleIds.indexOf(currentId);
    return vehicleIds[currentIndex + 1];
};

export const prevListVehicleId = (vehicleIds, currentId) => {
    const currentIndex = vehicleIds.indexOf(currentId);
    return vehicleIds[currentIndex - 1];
};